import { useEffect, useState } from "react";

// Viewport-based mobile detection (matches the app's 768px breakpoint).
// Unlike react-device-detect (user-agent based), this also works when a
// desktop browser is resized to a phone width — handy for previewing.
const QUERY = "(max-width: 767.98px)";

export default function useIsMobile() {
  const get = () =>
    typeof window !== "undefined" && window.matchMedia
      ? window.matchMedia(QUERY).matches
      : false;

  const [isMobile, setIsMobile] = useState(get);

  useEffect(() => {
    const mql = window.matchMedia(QUERY);
    const onChange = () => setIsMobile(mql.matches);
    onChange();
    mql.addEventListener ? mql.addEventListener("change", onChange) : mql.addListener(onChange);
    return () =>
      mql.removeEventListener ? mql.removeEventListener("change", onChange) : mql.removeListener(onChange);
  }, []);

  return isMobile;
}
